import { inject, Injectable } from '@angular/core';
import { ToastButton, ToastController, ToastOptions } from '@ionic/angular';
import { QbusTranslateService } from '../qbus-translate/qbus-translate.service';

interface QbusToastOptions {
  isDismissible?: boolean;
}

//// @deprecated use the new toast service in libs/shared
@Injectable({
  providedIn: 'root',
})
export class QbusToastService {
  private readonly toastController: ToastController = inject(ToastController);
  private readonly qbusTranslate: QbusTranslateService =
    inject(QbusTranslateService);

  async showSuccess(
    translationKey: string,
    overrideDefaultOptions: ToastOptions = {},
    qbusOptions: QbusToastOptions = {},
  ): Promise<void> {
    await this.show(
      translationKey,
      {
        // color: 'success',
        ...overrideDefaultOptions,
      },
      qbusOptions,
    );
  }

  async showError(
    translationKey: string,
    overrideDefaultOptions: ToastOptions = {},
    qbusOptions: QbusToastOptions = {},
  ): Promise<void> {
    await this.show(
      translationKey,
      {
        color: 'danger',
        ...overrideDefaultOptions,
      },
      qbusOptions,
    );
  }

  async showInfo(
    translationKey: string,
    overrideDefaultOptions: ToastOptions = {},
    qbusOptions: QbusToastOptions = {},
  ): Promise<void> {
    await this.show(translationKey, overrideDefaultOptions, qbusOptions);
  }

  /**
   * Show an ion toast.
   * @param translationKey translationKey of the message
   * @param overrideDefaultOptions override the default toast options
   * @param qbusOptions custom qbus options
   */
  async show(
    translationKey: string,
    overrideDefaultOptions: ToastOptions = {},
    qbusOptions: QbusToastOptions = {},
  ): Promise<void> {
    const { message } = await this.qbusTranslate.translateAll({
      message: translationKey,
    });

    const toastOptions: ToastOptions = {
      color: 'medium',
      message,
      duration: 2000,
      position: 'bottom',
      ...overrideDefaultOptions,
    };

    if (qbusOptions.isDismissible !== false) {
      const button: ToastButton = {
        icon: 'close',
        role: 'cancel',
      };

      if (toastOptions.buttons) {
        toastOptions.buttons.push(button);
      } else {
        toastOptions.buttons = [button];
      }
    }

    const toast = await this.toastController.create(toastOptions);

    await toast.present();
    await toast.onDidDismiss();
  }
}
